<li class="menuitem" [class]="logout ? 'menuitem--logout' : ''">
  @if (this.type === 'link') {
<a routerLink="{{destination}}" routerLinkActive="active">
    <i class="menuitem__icon fa-solid fa-{{icon}}"></i>
    <span class="menuitem__label">{{label}}</span>
    @if (countMessage !== 0 && router.url !== '/messagerie') {
<i class="fa-solid fa-circle ms-5" style="color: #FFED00"></i>
}
  </a>
} @else {

    <button (click)="this.onClick()">
      <i class="menuitem__icon fa-solid fa-{{icon}}"></i>
      <span class="menuitem__label">{{label}}</span>
    </button>
  
}
  
</li>
